import React, { useEffect, useRef, useState } from 'react';
import { ShoppingBag, Package, Palette, Sparkles, Truck } from 'lucide-react';

const HowItWorks = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const node = sectionRef.current;
    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, []);

  const steps = [
    {
      id: 1,
      icon: ShoppingBag,
      title: "Send Us Your Wishlist",
      description: "Drop those product links (Amazon, Nykaa, anywhere! or mix it) OR we'll literally come pickup from your doorstep. Your call! 🛍️"
    },
    {
      id: 2,
      icon: Package,
      title: "We Get Everything Ready",
      description: "We order everything from the links you sent OR pickup from you, then all products arrive at our studio. Easy peasy! 📦"
    },
    {
      id: 3,
      icon: Palette,
      title: "Pick Your Vibe",
      description: "Choose from our aesthetic themes (Romantic, Birthday, Luxury vibes) or go fully custom with your own ideas. We're here for it! 🎨"
    },
    {
      id: 4,
      icon: Sparkles,
      title: "Magic Happens",
      description: "Our team works their magic – gorgeous wrapping, cute ribbons, handwritten notes, literally all the aesthetic details! ✨"
    },
    {
      id: 5,
      icon: Truck,
      title: "Delivered to Delight",
      description: "Your beautifully packaged gift arrives ready to make someone's day absolutely amazing. You're gonna look like the best gift-giver ever! 🎁💕"
    }
  ];

  return (
    <section className="how-it-works-simple" ref={sectionRef}>
      <div className="how-it-works-simple-container">
        <div className={`how-it-works-simple-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="how-it-works-simple-title">
            How Does This <span className="title-emphasis">Magic Work?</span>
          </h2>
          <p className="how-it-works-simple-subtitle">
            Five super easy steps to leveling up your gifting game 🎮
          </p>
        </div>

        <div className="steps-simple-grid-five">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div 
                key={step.id} 
                className={`step-simple-card ${isVisible ? 'visible' : ''}`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="step-simple-number">{step.id}</div>
                <div className="step-simple-icon-wrapper">
                  <Icon className="step-simple-icon" />
                </div>
                <h3 className="step-simple-title">{step.title}</h3>
                <p className="step-simple-description">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
